import React from 'react'
import styled, { css } from 'styled-components'
import { Flex, Link } from '@raysync/common/components'
import intl from 'react-intl-universal'
import { Media, textEllipsis } from '@raysync/common/theme'

const BreadCrumbContainer = styled(Flex)`
  ${({ theme: { color } }) => css`
    padding: 32px 0;
    justify-content: flex-start;
    align-items: center;
    a {
      text-decoration: none;
      color: #333;
      font-size: 14px;
      flex-shrink: 0;
    }
    p {
      font-size: 14px;
      color: #999;
      ${textEllipsis};
    }
    ${Media.phone`
      font-size: .4rem;
    `}
  `}
`
export const Delimiter = styled.span`
  color: #333;
  font-size: 14px;
  margin: 0 3px;
`

class BreadCrumb extends React.PureComponent {
  render() {
    let { title, category } = this.props
    return (
      <BreadCrumbContainer>
        <Link to={'/news'}>{intl.get('news.title')}</Link>
        <Delimiter>&gt;</Delimiter>
        {category && (
          <>
            <Link to={`/news/category-${category.slug}/`}>{category.name}</Link>
            <Delimiter>&gt;</Delimiter>
          </>
        )}
        <p>{title}</p>
      </BreadCrumbContainer>
    )
  }
}

export default BreadCrumb
